import React, { useContext, useState } from "react";
import ContentLayout from "../../component/ContentLayout";
import axios from "../../util/axios";
import { Context } from "../../component/Context/ErrorContext";

const PushNotification = () => {
  const { setError } = useContext(Context);
  const [allUserFormState, setAllUserFormState] = useState({
    title: "",
    content: "",
  });
  const [loading, setLoading] = useState(false);
  const [singleUserFormState, setSingleUserFormState] = useState({
    title: "",
    content: "",
    email: "",
  });
  const allUserChangeHandler = (e: any) => {
    const name = e.target.name;
    const value = e.target.value;
    setAllUserFormState((prev) => ({ ...prev, [name]: value }));
  };
  const singleUserChangeHandler = (e: any) => {
    const name = e.target.name;
    const value = e.target.value;
    setSingleUserFormState((prev) => ({ ...prev, [name]: value }));
  };

  const sendAllUserNotification = () => {
    setLoading(true);
    const data = {
      ...allUserFormState,
      is_broadcast: true,
    };
    axios({
      URL: "/omw/admin/notification",
      method: "POST",
      data: data,
    })
      .then((res: any) => {
        setAllUserFormState({
          title: "",
          content: "",
        });
      })
      .catch((e) => setError(e.response?.data?.message))
      .finally(() => setLoading(false));
  };
  const sendSingleUserNotification = () => {
    const data = {
      ...singleUserFormState,
      is_broadcast: false,
    };
    setLoading(true);
    axios({
      URL: "/omw/admin/notification",
      method: "POST",
      data: data,
    })
      .then((res: any) => {
        setSingleUserFormState({
          title: "",
          content: "",
          email: "",
        });
      })
      .catch((e) => setError(e.response?.data?.message))
      .finally(() => setLoading(false));
  };
  return (
    <ContentLayout className={"items-start"}>
      <p className={"text-3xl font-bold text-secondary"}>Manage Notification</p>
      <div className={"w-full mt-4  bg-white p-2"}>
        <div className="text-secondary flex items-start text-xl font-bold">
          Instructions
        </div>
        <div className="text-start">
          <div className="leading-9">
            1.)Click on sync users button to refresh the user list{" "}
          </div>
          <div className="leading-9">
            2.)Then under "Update Notification" seciton add your new
            notification{" "}
          </div>
          <div className="leading-9">
            3.)Click on "Send Notification to All Users" to set the notification
            queue.
          </div>
          <div className="leading-9">
            4.)Schedule the notification to start the notification queue.
          </div>
          <div className="leading-9">
            5.)To send immediately set start time 12:00am and end time 12:00pm
          </div>
          <div className="leading-9">
            6.)In case the wrong notification have been added, terminate the
            entire notification queue by pressing the "Terminate Queue"
          </div>
        </div>
      </div>
      <div className={"w-full mt-4  bg-white"}>
        <div className="bg-red-100 text-start p-4">
          <div className="flex flex-wrap items-center gap-4">
            <span className="text-red-800 font-bold text-lg">Total:</span>
            <span className="text-red-500 text-lg">1,746,778</span>
            <span className="text-red-800 font-bold text-lg">Sent:</span>
            <span className="text-red-500 text-lg">1,746,778</span>
            <span className="text-red-800 font-bold text-lg">Not Sent:</span>
            <span className="text-red-500 text-lg">0</span>
          </div>
        </div>
        <div className="flex text-start gap-4 md:flex-row flex-col">
          <div className="w-full my-4 p-4 bg-white">
            <div className="flex justify-between items-center mb-4">
              <div className="text-xl font-semibold">Update Notification</div>
              <button className="bg-slate-500 p-2 text-sm text-white rounded-sm shadow-md hover:bg-secondary-dark focus:outline-none">
                Sync Users
              </button>
            </div>

            <div className="bg-secondary p-4 text-white">
              <div className="mb-4">
                <label className="block text-sm font-medium mb-1">
                  Notification Title*
                </label>
                <input
                  type="text"
                  name={"title"}
                  className="w-full p-2 border border-gray-300 rounded-md text-gray"
                  placeholder="Add Title..."
                  value={allUserFormState.title}
                  onChange={allUserChangeHandler}
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">
                  Message*
                </label>
                <input
                  type="text"
                  name={"content"}
                  className="w-full p-2 border border-gray-300 rounded-md text-gray"
                  placeholder="Message..."
                  value={allUserFormState.content}
                  onChange={allUserChangeHandler}
                />
              </div>
            </div>

            <div className="flex justify-between gap-4 mt-4">
              <button className="bg-red-500 p-2 text-sm text-white rounded-sm shadow-md hover:bg-red-600 focus:outline-none">
                Terminate Queue
              </button>

              <button
                className="bg-green p-2 text-sm text-white rounded-sm shadow-md hover:bg-green-600 focus:outline-none"
                onClick={sendAllUserNotification}
                disabled={loading}
              >
                Send Notification to All Users
              </button>
            </div>
          </div>

          <div className="w-full my-4 p-4 bg-white">
            <div className="text-xl font-semibold mb-4">
              Send Test Notification
            </div>

            <div className="bg-secondary text-white p-4">
              <div className="mb-4">
                <label className="block text-sm font-medium mb-1">
                  Enter Your Email*
                </label>
                <input
                  type="email"
                  className="w-full p-2 border border-gray-300 rounded-md text-gray"
                  placeholder="Enter your email..."
                  name={"email"}
                  value={singleUserFormState.email}
                  onChange={singleUserChangeHandler}
                />
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium mb-1">
                  Notification Title*
                </label>
                <input
                  type="text"
                  className="w-full p-2 border border-gray-300 rounded-md text-gray"
                  placeholder="Add Title..."
                  name={"title"}
                  value={singleUserFormState.title}
                  onChange={singleUserChangeHandler}
                />
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium mb-1">
                  Message*
                </label>
                <input
                  type="text"
                  className="w-full p-2 border border-gray-300 rounded-md text-gray"
                  placeholder="Message..."
                  name={"content"}
                  value={singleUserFormState.content}
                  onChange={singleUserChangeHandler}
                />
              </div>
            </div>
            <div className="flex justify-end gap-4 mt-4">
              <button
                className="bg-green p-2 text-sm text-white rounded-sm shadow-md hover:bg-green-600 focus:outline-none"
                onClick={sendSingleUserNotification}
                disabled={loading}
              >
                Send Test Notification
              </button>
            </div>
          </div>
        </div>
      </div>
    </ContentLayout>
  );
};

export default PushNotification;
